module Bookhus {

    export interface IPosition {
        lat: number;
        lng: number;
    }

    export enum MarkerType {
        house = 0,
        custom = 1
    }

    export interface IMarker {
        id: number;
        title: string;
        description: string;
        icon: string;
        position: IPosition;
        type: MarkerType;
    }

    export interface ISearchCridentials {
        arrivalDate: any;
        departureDate: any;
        lokation: number;
        days: number;
        personcount: number;
        freeseats: number;
        roomcount: number;
        opvaskemaskine: boolean;
        vaskemaskine: boolean;
        tørretumbler: boolean;
        husdyr: boolean;
        rygning: boolean;
        brændeovn: boolean;
        havDistance: boolean;
        købmandDistance: boolean;
        internet: boolean;
        parabol: boolean;
        handicapvenligt: boolean;
        havudsigt: boolean;
        maxprice: number;
        houseIds: string;

        spa: boolean;
        sauna: boolean;
        poolout: boolean;
        poolin: boolean;
        garage: boolean;
        boat: boolean;
        ekkolod: boolean;
        vhsradio: boolean;
        radar: boolean;
        mintwotoilets: boolean;
        fiskerenseplads: boolean;
        mikroovn: boolean;
        cykler: boolean;
        Feriecenter: boolean;
        Swimmingpool: boolean;
        Hus: boolean;
        Lejlighed: boolean;
        Skiområde: boolean;
        Storby: boolean;
        Bjergby: boolean;
        UdsigtVand: boolean;
        UdsigtNatur: boolean;

        GeoLokation: string[];
    }

    export interface IContentFilter {
        search(filter: ISearchCridentials);
    }

    export interface IEmneFilter {
        search(filter: ISearchCridentials, text: string):JQueryXHR;
    }

    export interface IItem {
        title: string;
        bookLink: string;
        isExternal: boolean;
    }

    export interface IHouseLocation {
        id: number;
        name: string;
        order: number;
        active: boolean;
    }

    export interface ICoordinates {
        latitude: number;
        longitude: number;
    }

    export interface IHouse2 {
        id: number;
        title: string;
        hasGooglemaps: boolean;
        userrelationshipLock: string;
        imageId: number;
        enabled: boolean;
        bookinglockDate: Date;
        useBookinglock: boolean;
        attributes: any[];
        tilsynsførende: number;
        deposit: number;
        houseLocations: IHouseLocation[];
        coordinates: ICoordinates;
    }

      
}